import * as React from "react";

import { Rating } from "@material-ui/core";
import { Star } from "@material-ui/icons";

import "./card.css";
import { NavLink } from "react-router-dom";

export default function RestaurantCard(props) {
  return (
    <NavLink to={`/restaurants/${props.id}`}>
      <div
        className="card"
        style={{
          marginBottom: 30,
          backgroundImage: `url(${props.imageUrl})`,
          height: 300,
          width: 425,
          marginRight: 20,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
      >
        <div
          style={{ backgroundColor: "#e5e5e5", opacity: 0.65, height: "30%" }}
        >
          <h3
            style={{
              marginLeft: "3%",
              marginTop: "2%",
              paddingBottom: "6px",
              fontSize: "25px",
            }}
          >
            {props.name}
          </h3>
          {/* <h2 style={{ marginLeft: "%", marginTop: "1%", fontSize: "25px" }}>
          {props.rate}
          <Rating
            sx={{ color: "#000d30" }}
            value={props.rate}
            readOnly
            precision={0.1}
            emptyIcon={<Star style={{ opacity: 0.6 }} />}
          />
        </h2> */}

          <h2
            style={{
              alignContent: "center",
              marginLeft: "3%",
              fontSize: "25px",
            }}
          >
            <Rating
              style={{ Bottom: "px" }}
              sx={{ color: "#000020" }}
              value={props.rate}
              readOnly
              size="large"
              precision={0.1}
              emptyIcon={
                <Star style={{ opacity: 0.6 }} sx={{ fontSize: 28 }} />
              }
            />
            {props.rate}
          </h2>
        </div>

        {/* <container className="container"> */}
        {/* <a target="_blank" href={`/restaurants/${props.id}`}></a> */}

        {/* <div className="info">
          <a className="name">{props.name}</a>
          <a className="rate">{props.rate}</a>
          <a className="star">
            <Rating
              sx={{ color: "#000d30" }}
              value={props.rate}
              readOnly
              precision={0.1}
              emptyIcon={<Star style={{ opacity: 0.6 }} />}
            />
          </a>
        </div>
      </container> */}
      </div>
    </NavLink>

    // <Link to={`/restaurants/${props.id}`}> Details </Link>
  );
}
